import { render, staticRenderFns } from "./UpdateConfiguration.vue?vue&type=template&id=b069f668&scoped=true&"
import script from "./UpdateConfiguration.vue?vue&type=script&lang=ts&"
export * from "./UpdateConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b069f668",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDivider,VForm,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b069f668')) {
      api.createRecord('b069f668', component.options)
    } else {
      api.reload('b069f668', component.options)
    }
    module.hot.accept("./UpdateConfiguration.vue?vue&type=template&id=b069f668&scoped=true&", function () {
      api.rerender('b069f668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/policies/UpdateConfiguration.vue"
export default component.exports